import { useMemo } from "react";
import { useToast as useChakraToast } from "@chakra-ui/react";

type ToastArgs = Parameters<typeof useChakraToast>[0]

export default function useToast(args?: ToastArgs) {
  const params = useMemo(() => {
    const _args = args || {}
    return {
      position: 'top',
      variant: 'default',
      colorScheme: 'brand',
      ..._args,
    } as ToastArgs
  }, [args])
  return useChakraToast(params)
}
